hasIssuedDeprecationWarningRef